module.exports = __webpack_public_path__ + "img/32.6704b8e2.png";